import { writable } from 'svelte/store';

export const toastMessage = writable("");

let timer;

export function showToast(msg, duration = 3000) {
    clearTimeout(timer);
    toastMessage.set(msg);
    timer = setTimeout(() => {
        toastMessage.set("");
    }, duration);
}
